import { init, browserTracingIntegration } from '@sentry/vue'

export default defineNuxtPlugin({
  parallel: true,
  setup(nuxtApp) {
    const router = useRouter()

    const { public: config } = useRuntimeConfig()

    const { dsn } = config.sentry

    if (!dsn) {
      return
    }

    const ignoreRegexErrors = [
      /(FetchError|Error).\[GET\].*[400|401|403|404]/,
      /(FetchError|Error).\[GET\].*<no response>/,
      /(FetchError|Error).\[POST\].*[400|401|403|422]/,
      /AbortError/,
      /AbortNavigation/,
      /TypeError.+Importing a module script failed/,
      /Error.+The operation was aborted/,
      /signal is aborted without reason/,
      /Failed to fetch/,
      /Load failed/
    ]

    init({
      app: nuxtApp.vueApp,
      dsn,
      environment: config.env,
      integrations: [browserTracingIntegration({ router })],

      beforeSend(event, hint) {
        const error = hint.originalException as { message?: string }

        if (error?.message) {
          for (const regex of ignoreRegexErrors) {
            if (error.message.match(regex)) {
              return null
            }
          }
        }
        return event
      }
    })
  }
})
